/**
 * URL to open or download a ticket attachment (preview / new tab).
 * Prefers documentPath, then url, then gateway attachment download endpoint.
 */
export function resolveAttachmentOpenUrl(attachment) {
  if (!attachment) return null;
  const documentPath = attachment.documentPath || attachment.document_path;
  if (documentPath) {
    const origin =
      window.location.hostname === 'localhost'
        ? 'https://helpdesk-pro.dhanushinfotech.com'
        : window.location.origin;
    return `${origin}${documentPath.startsWith('/') ? '' : '/'}${documentPath}`;
  }
  if (attachment.url && attachment.url !== '#') {
    const u = attachment.url;
    if (u.startsWith('http')) return u;
    const origin =
      window.location.hostname === 'localhost'
        ? 'https://helpdesk-pro.dhanushinfotech.com'
        : window.location.origin;
    return `${origin}${u.startsWith('/') ? '' : '/'}${u}`;
  }
  if (attachment.attachmentId) {
    return `${window.location.origin}/gateway/api/ticket/attachment/${attachment.attachmentId}/download`;
  }
  return null;
}
